import { price } from './formats'
import { findItemById } from './shopItems'

export function getShopItemPrice(shopItem) {
  return shopItem.discountPrice || shopItem.price
}

export function getShopItemOriginalPrice(shopItem) {
  if (shopItem.regularPrice) {
    return shopItem.regularPrice
  } else if (shopItem.price) {
    return shopItem.price
  } else {
    return null
  }
}

export function formatShopItemOriginalPrice(shopItem) {
  if (shopItem.regularPrice) {
    return price(shopItem.regularPrice.priceCents, shopItem.regularPrice.currency)
  } else if (shopItem.price) {
    return price(shopItem.price.priceCents, shopItem.price.currency)
  } else {
    return 'N/A'
  }
}

export function formatShopItemDiscountPrice(shopItem) {
  return shopItem.discountPrice ? price(shopItem.discountPrice.priceCents, shopItem.discountPrice.currency) : null
}

export function isBundle(shopItem) {
  return shopItem.bundledItemTypes && shopItem.bundledItemTypes.length
}

export const isInCart = (shopItem, shoppingCart) => {
  return shoppingCart[shopItem.id] > 0
}

export const calculatePriceForMultipleShopItems = (items) => {
  if (!items || !items.length) {
    return null
  }

  if (items.some(i => !i.price)) {
    return null
  }

  const allPriceCents = items
      .map(i => getShopItemPrice(i).priceCents)
      .reduce((partialSum, a) => partialSum + a, 0)
  return { priceCents: allPriceCents, currency: items[0].price.currency }
}

export const calculateDiscountFromRegularPriceCents = (items) => {
  return items
    .map(i => i.discountFromRegularPriceCents || 0)
    .reduce((partialSum, a) => partialSum + a, 0)
}

export const findBundleByBundledItemTypes = (shopItems, bundledItemTypes) => {
  return shopItems.find(i => i.bundledItemTypes && [...i.bundledItemTypes].sort().join(',') === [...bundledItemTypes].sort().join(','))
}

export const calculateShoppingCartTotal = (shopItems, shoppingCart) => {
  // if none of the items have a price (from which we extract the currency), return 0 as total
  const currency = shopItems.find(i => !!i.price) ? shopItems.find(i => !!i.price).price.currency : null
  if (!currency) {
    return { priceCents: 0, currency: 'N/A' }
  }

  let total = 0

  // transform cart from { ITEM_A: 2, ITEM_B: 1 } -> [ ITEM_A, ITEM_A, ITEM_B, ITEM_B, ITEM_B ]
  let cartFlattened = Object.keys(shoppingCart).flatMap(k => Array(shoppingCart[k]).fill(k))
  cartFlattened.forEach(itemType => {
    const item = findItemById(itemType,  shopItems)
    // An item can be present in the region's shopItems (from the catalog join) yet
    // carry no price when it is unavailable in the current region — e.g. a rig left
    // in the cart while browsing /us or /au. getShopItemPrice() is then undefined,
    // so guard before reading priceCents (was throwing and blanking the shop).
    const itemPrice = item && getShopItemPrice(item)
    if (itemPrice) {
      total += itemPrice.priceCents
    }
  })

  // `currency` is derived above from the first PRICED item; shopItems[0] itself may
  // be a price-less (unavailable) item, so reuse `currency` rather than shopItems[0].
  return {
    priceCents: total,
    currency,
  }
}

export const calculateShoppingCartDiscount = (shopItems, shoppingCart) => {
  let discount = 0

  // transform cart from { ITEM_A: 2, ITEM_B: 1 } -> [ ITEM_A, ITEM_A, ITEM_B, ITEM_B, ITEM_B ]
  let cartFlattened = Object.keys(shoppingCart).flatMap(k => Array(shoppingCart[k]).fill(k))
  cartFlattened.forEach(itemType => {
    const item = findItemById(itemType,  shopItems)
    if (!!item) {
      discount += (item.discountFromRegularPriceCents || 0)
    }
  })

  return discount
}
